import { useTranslation } from 'react-i18next';
import { useCurrentContext } from '../app/ViewContext';
import { Block, EventArt, INK_SOFT, PageHead } from '../design/forms';
import { ParentCare } from './ParentCare';
import { Private } from './shared';
import { StaffCare } from './StaffCare';
import { StudentCare } from './StudentCare';

/** «Турбота»: the student's way to the psychologist, the family's advice, the psychologist's desk. */
export function CarePage() {
  const { t } = useTranslation();
  const ctx = useCurrentContext();
  switch (ctx.kind) {
    case 'student':
      return <StudentCare key={ctx.key} ctx={ctx} />;
    case 'guardian':
      return <ParentCare key={ctx.key} ctx={ctx} />;
    case 'psychologist':
    case 'admin':
      // the administration sees bullying reports only — and only the director (by the database)
      return <StaffCare key={ctx.key} ctx={ctx} />;
    case 'teacher':
      return (
        <div className="flex flex-col gap-4">
          <PageHead title={t('care.title')} />
          <Block className="items-center py-12 text-center">
            <EventArt kind="meeting" tone="lavender" size={88} />
            <div className="mt-4 max-w-xl" style={{ color: INK_SOFT }}>
              <Private className="justify-center text-left !text-[15px] !leading-[22px]">
                {t('care.staff.directorOnly')}
              </Private>
            </div>
          </Block>
        </div>
      );
  }
}
